/** The words the family sees for a transaction (skill 13 — no ledger vocabulary). */
import type { PlanningNature, TransferPurpose } from '@pfo/domain';

export const ENTRY_TYPE_LABELS: Record<string, string> = {
  expense: 'Chi',
  income: 'Thu',
  transfer: 'Chuyển tiền',
  split: 'Chia tiền',
  debt_payment: 'Trả nợ',
  opening: 'Số dư đầu kỳ',
  adjustment: 'Điều chỉnh',
  summary_adjustment: 'Điều chỉnh theo tổng',
};

/**
 * Why the money went out — the input behind "planned vs unexpected" in the report (spec §10).
 * Left unset by default: Quick Add must not ask five questions to record a coffee.
 */
export const PLANNING_NATURE_LABELS: Record<PlanningNature, string> = {
  fixed_recurring: 'Cố định hằng tháng',
  planned_variable: 'Có kế hoạch, số tiền thay đổi',
  planned_one_off: 'Có kế hoạch, một lần',
  discretionary: 'Tuỳ ý',
  unexpected: 'Ngoài dự kiến',
  emergency: 'Khẩn cấp',
};

/**
 * Where a row came from. 'manual' is not labelled — most rows are typed by hand and a badge
 * on every one of them would say nothing.
 */
export const SOURCE_LABELS: Record<string, string> = {
  recurring: 'Định kỳ',
  momo_summary: 'Tổng MoMo',
  import: 'Nhập từ file',
  ssi: 'SSI',
  system: 'Hệ thống',
  // Posted from a bank's confirmation email after the person approved it (AL1).
  bank_notice: 'Email NH',
};

/**
 * Why money was moved between our own accounts (A3, spec §9). Left unset by default — the
 * report already infers saving, reserve and investment from the destination account type.
 * Saying it explicitly only matters when the account type does not: money parked in an
 * ordinary bank account that is really an investment contribution.
 */
export const TRANSFER_PURPOSE_LABELS: Record<TransferPurpose, string> = {
  regular_saving: 'Tiết kiệm',
  emergency_fund: 'Quỹ dự phòng',
  sinking_fund: 'Quỹ mục tiêu',
  investment_contribution: 'Góp vốn đầu tư',
  debt_repayment: 'Trả nợ',
  family_support: 'Cho gia đình',
  other: 'Khác',
};
